module.exports = __webpack_public_path__ + "img/landing-deco.20b1141.svg";